import { ApiResponse } from "@/utils/ApiResponse";
import { resetPasswordInterface } from "../interfaces/resetPassword.interface";
import apiClient from "@/clients/apiClient";

export async function resetPasswordAction(
  newPassword: string,
  token: string
): Promise<ApiResponse<resetPasswordInterface>> {
  const { data } = await apiClient.post<resetPasswordInterface>(
    "/auth/resetPassword",
    { newPassword, token }
  );
  return {
    status: 200,
    data,
    message: "Contraseña restablecida correctamente",
  };
}
